<div class="racebottom">
    <fieldset [ngClass]="enrol.isPhoneEnrollment ? 'marginLeft10 input-wrapper' : 'input-wrapper'">
        <legend *ngIf="isSpanish"
            [ngClass]="{ 'blue-text bottom-20 phoneEnrollmentRaceEthlbl' : enrol.isPhoneEnrollment }">¿Eres hispano,
            latino/a o de origen español? Seleccione todas las que correspondan (opcional)</legend>
        <legend *ngIf="!isSpanish"
            [ngClass]="{ 'blue-text bottom-20 phoneEnrollmentRaceEthlbl' : enrol.isPhoneEnrollment }">
            Are <span *ngIf="enrol.isPhoneEnrollment">{{this.spnyouthey}}</span> <span
                *ngIf="enrol.isPhoneEnrollment==undefined || !enrol.isPhoneEnrollment">you</span> Hispanic, Latino/a, or
            Spanish origin? Select all that apply. (Optional)
        </legend>

        <div class="row checkmargin">
            <div *ngFor="let ethnicity of ethnicityList">
                <input id="{{'Ethnicity' + '_' + ethnicity.EthnicityCode}}" value="{{ethnicity.EthnicityCode}}"
                    class="option__input" type="checkbox" name="{{'Ethnicity'}}"
                    (change)="onEthnicityDynamamicChange(ethnicity)" [(ngModel)]="ethnicity.IsChecked" />

                <label class="option" for="{{'Ethnicity' + '_' + ethnicity.EthnicityCode}}"
                    [ngClass]="ethnicity.EthnicityCode==='NR' ? 'boldfont' : ''">{{ethnicity.Description}}</label>

            </div>
        </div>
    </fieldset>
</div>

<div class="row">
    <div class="racecontent">
        <fieldset [ngClass]="enrol.isPhoneEnrollment ? 'marginLeft10 input-wrapper' : 'input-wrapper'">
            <legend *ngIf="isSpanish"
                [ngClass]="{ 'blue-text bottom-20 phoneEnrollmentRaceEthlbl' : enrol.isPhoneEnrollment }">¿Cual es su
                raza? Seleccione todas las que correspondan (opcional)</legend>
            <legend *ngIf="!isSpanish"
                [ngClass]="{ 'blue-text bottom-20 phoneEnrollmentRaceEthlbl' : enrol.isPhoneEnrollment }">
                What is <span *ngIf="enrol.isPhoneEnrollment">{{this.spnYourTheir}}</span> <span
                    *ngIf="enrol.isPhoneEnrollment==undefined || !enrol.isPhoneEnrollment">your</span> race? Select all
                that apply. (Optional)
            </legend>
            <div class="row">
                <div *ngFor="let race of raceList">
                    <div
                        [ngClass]="{ 'col-5' : race.DisplayColumn==2,'col-6' : race.DisplayColumn==3,'col-6' : race.DisplayColumn==1 }">
                        <div *ngIf="race.DisplayColumn==1 && race.RaceCode!='999'">
                            <input id="{{'Race' + '_' + race.RaceCode}}" value="{{race.RaceCode}}" type="checkbox"
                                name="{{'Race'}}" (change)="onRaceDynamamicChange(race)" [(ngModel)]="race.IsChecked" />

                            <label for="{{'Race' + '_' + race.RaceCode}}">{{race.Description}}</label>
                        </div>
                        <div *ngIf="race.DisplayColumn==2">
                            <input id="{{'Race' + '_' + race.RaceCode}}" value="{{race.RaceCode}}" type="checkbox"
                                name="{{'Race'}}" (change)="onRaceDynamamicChange(race)" [(ngModel)]="race.IsChecked" />

                            <label for="{{'Race' + '_' + race.RaceCode}}">{{race.Description}}</label>
                        </div>
                        <div *ngIf="race.DisplayColumn==3">
                            <input id="{{'Race' + '_' + race.RaceCode}}" value="{{race.RaceCode}}" type="checkbox"
                                name="{{'Race'}}" (change)="onRaceDynamamicChange(race)" [(ngModel)]="race.IsChecked" />

                            <label for="{{'Race' + '_' + race.RaceCode}}">{{race.Description}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngFor="let race of raceList">
                <div class="col-6" *ngIf="race.DisplayColumn==1 && race.Sequence==99">
                    <input id="{{'Race' + '_' + race.RaceCode}}" value="{{race.RaceCode}}" type="checkbox"
                        name="{{'Race'}}" (change)="onRaceDynamamicChange(race)" [(ngModel)]="race.IsChecked" />

                    <label for="{{'Race' + '_' + race.RaceCode}}">{{race.Description}}</label>
                </div>
            </div>
        </fieldset>
    </div>
</div>